module.exports = __webpack_public_path__ + "img/industry_solution5.277054ca.png";